<template>
  <MainViewContainer>
    <div class="col-span-12 md:col-span-6 discussions-column discussions-column--messages">
      <DirectMessageListing />
    </div>

    <div class="col-span-12 md:col-span-6 discussions-column discussions-column--threads">
      <PublicDiscussionsList />
    </div>
  </MainViewContainer>
</template>

<script setup>
import MainViewContainer from '@/components/MainViewContainer'
import DirectMessageListing from '@/components/discussions/DirectMessageListing'
import PublicDiscussionsList from '@/components/discussions/PublicDiscussionsList'
</script>

<style scoped>

.discussions-column {
  min-width: 0;
}

@media (min-width: 768px) {
  .discussions-column--threads {
    border-left: 1px solid var(--gray-200);
    padding-left: 1.5rem;
  }
}
</style>
